import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Toaster } from "./ui/sonner";

export default function Layout() {
  return (
    <div className="flex bg-[#F5F5F5] min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0 pb-24">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
